module.exports = __webpack_public_path__ + "static/media/obwtech.504cde27.png";